import React from "react";
import { Link } from "react-router-dom";
import { HOME_BOXES } from "../mock";
import {
  MessageCircle,
  Search,
  ArrowRight,
  ArrowLeft,
  Target,
  Table2,
  Smartphone,
  CircleDot,
  Star,
} from "lucide-react";

function Stars() {
  return (
    <div className="box-stars">
      <Star className="w-3 h-3 fill-current" />
      <span className="line" />
      <Star className="w-3.5 h-3.5 fill-current" />
      <span className="line" />
      <Star className="w-3 h-3 fill-current" />
    </div>
  );
}

function LetterBox({ letter, label, accent }) {
  return (
    <>
      <div className="badge-glow" style={{ color: accent }}>
        <span style={{ color: accent }}>{letter}</span>
      </div>
      <div className="box-label text-sm sm:text-lg">{label}</div>
      <Stars />
    </>
  );
}

function BlogBox() {
  return (
    <>
      <div className="relative mb-2">
        <div className="badge-glow" style={{ color: "#e8491d", background: "#fff", borderColor: "#0e2a47" }}>
          <span style={{ color: "#0e2a47" }}>B</span>
        </div>
        <MessageCircle className="w-4 h-4 absolute -top-1 -right-1 text-[#e8491d] fill-[#e8491d]" />
      </div>
      <div className="box-label text-lg sm:text-2xl">
        <span className="text-[#e8491d]">B</span>
        <span className="text-[#0e2a47]">log</span>
      </div>
      <div className="box-stars text-[#0e2a47]">
        <Star className="w-3 h-3 fill-current" />
        <span className="line" />
        <Star className="w-3 h-3 fill-current" />
      </div>
    </>
  );
}

function IconBox({ icon, label }) {
  const icons = {
    chart: <Search className="w-12 h-12 sm:w-16 sm:h-16" strokeWidth={2.2} />,
    target: <Target className="w-12 h-12 sm:w-16 sm:h-16" strokeWidth={2.2} />,
    table: <Table2 className="w-12 h-12 sm:w-16 sm:h-16" strokeWidth={2.2} />,
    counter: <CircleDot className="w-12 h-12 sm:w-16 sm:h-16 text-[#e8491d]" strokeWidth={2.2} />,
    phone: <Smartphone className="w-12 h-12 sm:w-16 sm:h-16" strokeWidth={2.2} />,
  };
  const twoLine = label.split(" ");
  return (
    <>
      <div className="badge-icon-glow">{icons[icon]}</div>
      <div className="box-label text-sm sm:text-xl leading-tight">
        {twoLine.length > 2 ? (
          <>
            {twoLine.slice(0, -1).join(" ")}
            <br />
            {twoLine.slice(-1)}
          </>
        ) : (
          label
        )}
      </div>
      <Stars />
    </>
  );
}

function PredictBox() {
  const rows = [
    { letter: "D", label: "Direct Number", color: "#f2a516", dir: "right" },
    { letter: "H", label: "House", color: "#e8f0e8", dir: "left" },
    { letter: "E", label: "Ending", color: "#e8491d", dir: "left" },
  ];
  return (
    <>
      <div className="flex flex-col gap-1.5 w-full px-4 sm:px-6 mb-1">
        {rows.map((r) => (
          <div key={r.letter} className="flex items-center gap-1.5 text-[11px] sm:text-xs font-bold">
            {r.dir === "right" ? (
              <ArrowRight className="w-4 h-4 shrink-0" style={{ color: r.color }} />
            ) : (
              <ArrowLeft className="w-4 h-4 shrink-0" style={{ color: r.color }} />
            )}
            <span
              className="w-4 h-4 rounded-full flex items-center justify-center text-[9px] font-black text-black shrink-0"
              style={{ background: r.color }}
            >
              {r.letter}
            </span>
            <span>{r.label}</span>
          </div>
        ))}
      </div>
      <div className="box-label text-sm sm:text-lg mt-1">Predict Target</div>
    </>
  );
}

function BoxVisual({ box }) {
  if (box.key === "common") return <LetterBox letter="C" label="Common Number" accent="#ff7a3d" />;
  if (box.key === "dream") return <LetterBox letter="D" label="Dream Number" accent="#ff7a3d" />;
  if (box.key === "blog") return <BlogBox />;
  if (box.key === "predict") return <PredictBox />;
  return <IconBox icon={box.icon} label={box.label} />;
}

export default function BoxGrid() {
  return (
    <div className="grid grid-cols-3 gap-3 sm:gap-5 max-w-3xl mx-auto">
      {HOME_BOXES.map((box) => (
        <Link
          key={box.key}
          to={box.to}
          className={`teer-box ${box.theme === "orange" ? "orange-glow text-white" : `theme-${box.theme}`}`}
        >
          <BoxVisual box={box} />
        </Link>
      ))}
    </div>
  );
}
